// src/components/site/SiteFooter.tsx — Site officiel Vanessa
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { FOOTER_COLUMNS, CONTACT_EMAIL, PUBLISHER } from '@/config/site';

export const SiteFooter = () => (
    <footer className="mt-20 border-t border-gray-200 bg-sand">
        <div className="mx-auto max-w-6xl px-4 py-12">
            <div className="grid gap-10 md:grid-cols-[1.3fr_repeat(5,1fr)]">
                <div>
                    <Link to="/" className="flex items-center gap-2.5">
                        <img src="/vanessa-avatar.png" alt="" className="h-10 w-10 rounded-full object-cover ring-2 ring-brand" />
                        <span className="font-display text-xl font-bold text-ink">Vanessa</span>
                    </Link>
                    <p className="mt-3 max-w-xs text-sm text-gray-700">
                        Celle qui vous ressemble et vous rassemble.
                    </p>
                    <a
                        href={`mailto:${CONTACT_EMAIL}`}
                        className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-ochre hover:underline"
                    >
                        <Mail className="w-4 h-4" aria-hidden="true" />
                        {CONTACT_EMAIL}
                    </a>
                </div>

                {FOOTER_COLUMNS.map((col) => (
                    <nav key={col.title} aria-label={col.title}>
                        <p className="font-display text-sm font-semibold text-ink">{col.title}</p>
                        <ul className="mt-3 space-y-2">
                            {col.links.map((link) => (
                                <li key={link.to}>
                                    <Link to={link.to} className="text-sm text-gray-700 hover:text-ink hover:underline">
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>
                ))}
            </div>

            <div className="mt-10 flex flex-col gap-2 border-t border-gray-300 pt-6 text-sm text-gray-600 sm:flex-row sm:justify-between">
                <p>© {new Date().getFullYear()} {PUBLISHER} — éditeur de la plateforme Vanessa.</p>
                <p>Vanessa est une intelligence artificielle. Elle peut se tromper.</p>
            </div>
        </div>
    </footer>
);
